import { Box, type BoxProps } from "@mui/material";
import { type ReactNode } from "react";

export interface VisitorsHomeTemplateProps {
  activeVisitorsSection: ReactNode;
  chartSlot: ReactNode;
  upcomingVisitorsSection: ReactNode;
  visitorActionsSlot: ReactNode;
  rootSx?: BoxProps["sx"];
}

export function VisitorsHomeTemplate({
  activeVisitorsSection,
  chartSlot,
  upcomingVisitorsSection,
  visitorActionsSlot,
  rootSx,
}: VisitorsHomeTemplateProps) {
  return (
    <Box sx={rootSx}>
      {visitorActionsSlot}
      {chartSlot}
      {activeVisitorsSection}
      {upcomingVisitorsSection}
    </Box>
  );
}
